import { useContext } from "react";
import { ShoppingCartContext } from "@contexts/ShoppingCartContext2";

export const useShoppingCart = () => {
  const context = useContext(ShoppingCartContext);
  return context;
};
